import './PerformResultModal.css';
import ModalPortal from '../modal/ModalPortal';
import { formatPercent } from '../../utils/formatMetric';

export type PerformResultPilot = {
  pilot: string;
  hours: number;
  percent: number;
};

type Props = {
  title: string;
  hobbs: number;
  periodHours: number;
  pilots: PerformResultPilot[];
  onClose: () => void;
};

const BAR_COLORS = [
  '#159ea3',
  '#2980b9',
  '#27ae60',
  '#e67e22',
  '#8e44ad',
  '#c0392b',
  '#16a085',
];

const PerformResultModal = ({
  title,
  hobbs,
  periodHours,
  pilots,
  onClose,
}: Props) => {
  const sorted = [...pilots].sort((a, b) => b.percent - a.percent);

  return (
    <ModalPortal>
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal perform-result-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="perform-result-badge">Готово</div>
        <h3>{title} проведено</h3>
        <div className="perform-result-meta">
          <div className="perform-result-meta-item">
            <span className="perform-result-meta-label">Наработка</span>
            <span className="perform-result-meta-value">{hobbs} м/ч</span>
          </div>
          <div className="perform-result-meta-item">
            <span className="perform-result-meta-label">Период</span>
            <span className="perform-result-meta-value">{periodHours} м/ч</span>
          </div>
        </div>

        {sorted.length > 0 ? (
          <div className="perform-result-share">
            <div className="perform-result-share-title">Распределение налёта</div>
            <ul className="perform-result-list">
              {sorted.map((p, index) => {
                const width = Math.max(0, Math.min(100, Number(p.percent) || 0));
                const color = BAR_COLORS[index % BAR_COLORS.length];
                return (
                  <li key={`${p.pilot}-${index}`} className="perform-result-row">
                    <div className="perform-result-row-head">
                      <span className="perform-result-name">{p.pilot}</span>
                      <span className="perform-result-percent">
                        {formatPercent(p.percent)}%
                      </span>
                    </div>
                    <div className="perform-result-bar-track">
                      <div
                        className="perform-result-bar-fill"
                        style={{ width: `${width}%`, background: color }}
                      />
                    </div>
                    <div className="perform-result-hours">{p.hours} м/ч</div>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <p className="perform-result-empty">Нет данных по пилотам за период</p>
        )}

        <div className="modal-actions">
          <button type="button" className="btn-save" onClick={onClose}>
            ОК
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default PerformResultModal;
